import { zodResolver } from '@hookform/resolvers/zod';
import { SquarePen, X } from 'lucide-react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { categorySchema } from '../validations/addMainCategoryForm';
import { useUpdateMainCategory } from '../hooks/useUpdateMainCategory';

export const EditCategoryModal = (props) => {
  const { isEditModalOpen, setIsEditModalOpen, category } = props;
  const { mutate: updateMainCategory, isPending } = useUpdateMainCategory();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: zodResolver(categorySchema),
  });

  useEffect(() => {
    if (category) {
      reset({
        name: category.name,
        description: category.description,
        icon: category.icon || '',
        image: category.image || '',
        color: category.color || '',
        displayOrder: category.displayOrder,
        isActive: category.isActive,
        isPopular: category.isPopular,
        isFeatured: category.isFeatured,
        seo: {
          metaTitle: category.seo?.metaTitle || '',
          metaDescription: category.seo?.metaDescription || '',
          keywordsString: category.seo?.keywords?.join(', ') || '',
        },
      });
    }
  }, [category, reset]);

  const onSubmit = (data) => {
    const payload = { categoryId: category._id, data };

    updateMainCategory(payload, {
      onSuccess: () => {
        reset();
        setIsEditModalOpen(false);
      },
    });
  };

  if (!isEditModalOpen) return null;

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto custom-scrollbar'>
        {/* Header */}
        <div className='sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between'>
          <h2 className='text-lg font-semibold'>Edit Category</h2>
          <button onClick={() => setIsEditModalOpen(false)} className='p-1 hover:bg-muted rounded-md transition-colors'>
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit, (err) => console.log('ERRORS:', err))} className='p-6 space-y-6'>
          {/* Name Section */}
          {/* <div className='space-y-4'>
            <h3 className='text-sm font-semibold text-foreground'>Name (Multilingual)</h3>

            <div>
              <label className='block text-sm font-medium mb-1'>English Name *</label>
              <input type='text' {...register('name.english')} className='w-full px-3 py-2 text-sm' />
              {errors.name?.english && <p className='text-destructive text-xs mt-1'>{errors.name.english.message}</p>}
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Hindi Name</label> 
              <input type='text' {...register('name.hindi')} className='w-full px-3 py-2 text-sm' />
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Marwari Name</label>
              <input type='text' {...register('name.marwari')} className='w-full px-3 py-2 text-sm' />
            </div>
          </div> */}

          {/* Description Section */}
          {/* <div className='space-y-4'>
            <h3 className='text-sm font-semibold text-foreground'>Description (Multilingual)</h3>

            <div>
              <label className='block text-sm font-medium mb-1'>English Description</label>
              <textarea {...register('description.english')} rows={3} className='w-full px-3 py-2 text-sm' />
              {errors.description?.english && (
                <p className='text-destructive text-xs mt-1'>{errors.description.english.message}</p>
              )}
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Hindi Description</label>
              <textarea {...register('description.hindi')} rows={3} className='w-full px-3 py-2 text-sm' />
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Marwari Description</label>
              <textarea {...register('description.marwari')} rows={3} className='w-full px-3 py-2 text-sm' />
            </div>
          </div> */}

          {/* Media & Display */}
          <div className='space-y-4'>
            <h3 className='text-sm font-semibold text-foreground'>Media & Display</h3>

            {/* <div>
              <label className='block text-sm font-medium mb-1'>Icon URL</label>
              <input
                type='text'
                {...register('icon')}
                className='w-full px-3 py-2 text-sm'
                placeholder='https://example.com/icon.jpg'
              />
              {errors.icon && <p className='text-destructive text-xs mt-1'>{errors.icon.message}</p>}
            </div> */}

            <div>
  <label className='block text-sm font-medium mb-1'>Image URL</label>
  <input
    type='text'
    {...register('image')}
    className='w-full px-3 py-2 text-sm'
    placeholder='https://example.com/image.jpg'
  />
  {errors.image && <p className='text-destructive text-xs mt-1'>{errors.image.message}</p>}

  {/* Image Preview */}
  {watch('image') && (
    <div className='mt-2'>
      <img
        src={watch('image')}
        alt='Preview'
        className='h-32 w-32 object-cover rounded-md border border-border'
        onError={(e) => e.target.style.display = 'none'}
        onLoad={(e) => e.target.style.display = 'block'}
      />
    </div>
  )}
</div>

            {/* <div>
              <label className='block text-sm font-medium mb-1'>Color</label>
              <input type='text' {...register('color')} className='w-full px-3 py-2 text-sm' placeholder='#FF5733' />
            </div>

            <div>
              <label className='block text-sm font-medium mb-1'>Display Order</label>
              <input
                type='number'
                {...register('displayOrder', { valueAsNumber: true })}
                className='w-full px-3 py-2 text-sm'
              />
            </div>
          </div>

          <div className='space-y-4'>
            <h3 className='text-sm font-semibold text-foreground'>SEO</h3> */}

            {/* Meta Title */}
            {/* <div>
              <label className='block text-sm font-medium mb-1'>Meta Title *</label>
              <input
                type='text'
                {...register('seo.metaTitle')}
                className='w-full px-3 py-2 text-sm'
                placeholder='Category meta title'
              />
              {errors.seo?.metaTitle && <p className='text-destructive text-xs mt-1'>{errors.seo.metaTitle.message}</p>}
            </div> */}

            {/* Meta Description */}
            {/* <div>
              <label className='block text-sm font-medium mb-1'>Meta Description *</label>
              <textarea
                {...register('seo.metaDescription')}
                rows={3}
                className='w-full px-3 py-2 text-sm'
                placeholder='Category meta description'
              />
              {errors.seo?.metaDescription && (
                <p className='text-destructive text-xs mt-1'>{errors.seo.metaDescription.message}</p>
              )}
            </div> */}

            {/* Keywords / Tags */}
            {/* <div>
              <label className='block text-sm font-medium mb-1'>Tags (comma separated)</label>
              <input
                type='text'
                {...register('seo.keywordsString')}
                className='w-full px-3 py-2 text-sm'
                placeholder='tag1, tag2, tag3'
              />
            </div> */}
          </div>

          {/* Settings */}
          {/* <div className='space-y-3'>
            <h3 className='text-sm font-semibold text-foreground'>Settings</h3>

            <label className='flex items-center space-x-2 cursor-pointer'>
              <input type='checkbox' {...register('isActive')} className='rounded' />
              <span className='text-sm'>Active</span>
            </label>

            <label className='flex items-center space-x-2 cursor-pointer'>
              <input type='checkbox' {...register('isPopular')} className='rounded' />
              <span className='text-sm'>Popular</span>
            </label>

            <label className='flex items-center space-x-2 cursor-pointer'>
              <input type='checkbox' {...register('isFeatured')} className='rounded' />
              <span className='text-sm'>Featured</span>
            </label>
          </div> */}

          {/* Actions */}
          <div className='flex justify-end space-x-3 pt-4 border-t border-border'>
            <button
              type='button'
              onClick={() => setIsEditModalOpen(false)}
              className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors'
            >
              Cancel
            </button>
            <button
              type='submit'
              disabled={isPending}
              className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50'
            >
              {isPending ? (
                <div className='flex items-center justify-center'>
                  <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
                  Updating...
                </div>
              ) : (
                <div className='flex items-center justify-center'>
                  <SquarePen size={16} className='mr-2' />
                  Update Main Category
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
